<template>
  <div class="circular-progress" :id="id" v-if="theme == 'light'"></div>
  <div class="circular-progress" :id="id" v-if="theme == 'medium'" ></div>
  <div class="circular-progress" :id="id" v-if="theme == 'dark'" :per="per"></div>
</template>

<script>
import store from "@/store";
import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
highchartsMore(Highcharts);
solidGauge(Highcharts);

export default {
  name: "CircularProgressV3",
  props: ["id","per","name"],
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    },
  },  
  updated() {
   this.renderChart();
  },
  mounted() {
    this.renderChart();
    document.querySelectorAll('.highcharts-credits').forEach(item => item.style.display = 'none');
  },
  methods: {
    renderChart: function(){

      Highcharts.chart(this.id, {
      chart: {
        type: "solidgauge",
        height: "153px",
        backgroundColor: 'transparent'
        /* events: {
      render() {
        let chart = this,
          label1 = chart.series[0].dataLabelsGroup,
          label2 = chart.series[1].dataLabelsGroup;
    
        label1.translate(chart.marginRight, 0)
        label2.translate(chart.marginRight, chart.marginBottom + label2.getBBox().height)
      }
    } */
      },
      title: "",
      tooltip: {
        enabled: false
      },
      pane: {
        startAngle: 0,
        endAngle: 360,
        background: [
          {
            outerRadius: "103%",
            innerRadius: "100%",
            backgroundColor: this.theme == 'light'? "#E7E7E7" : this.theme =='medium' ? '#FFFFFF'  : 'rgba(255, 255, 255, 0.13)',
            borderWidth: 0,
          },
        ],
        size: "80%",
      },

      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: [],
      },

      plotOptions: {
        solidgauge: {
          center: ["50%", "50%"],
        },
      },

      series: [
        {
          name: this.name,
          data: [
            {
              color: "#F5B335",
              radius: "112%",
              innerRadius: "100%",
              y: parseInt(this.per),
              dataLabels: {
                align: 'center',
                verticalAlign: 'middle',
                y: -0,
                x: 5,
                format: "<div style='font-family:Source Sans Pro,sans-serif; font-size: 24px, font-weight:700'>{y}%</div>",
                borderWidth: 0,
                className: 'cust-label',
                style: {
                  fontSize: "24px",
                  color: (this.theme=='light' || this.theme =='medium') ? "#527A7A" : '#fff',
                  textOutline: 0
                },
              },
            },
          ],
        },
      ],
    });
    document
      .querySelectorAll(".highcharts-credits")
      .forEach((item) => (item.style.display = "none"));
    }
  }
};
</script>

<style lang='scss' scoped>
body.theme-light,body.theme-medium, body.theme-dark {
    .circular-progress {
        width: 153px !important;
        height: 153px !important;
    }
    #circular-progress {
        margin: 0 auto;
        padding-top: 5px;
        .cust-label {
            margin-top: 10px;
            transform:"translate(30,55)" !important;
        }
    }
}

</style>